import { createPortal } from 'react-dom'
import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

// Tailwind CSS classes are used for styling
const SaveChatflowDialog = ({ show, dialogProps, onCancel, onConfirm, flowName }) => {
    const [portalElement, setPortalElement] = useState<HTMLElement | null>(null)
    const [chatflowName, setChatflowName] = useState('')
    const [isReadyToSave, setIsReadyToSave] = useState(false)

    useEffect(() => {
        setPortalElement(document.getElementById('portal'));
    }, [show]);

    useEffect(() => {
        if (chatflowName) setIsReadyToSave(true)
        else setIsReadyToSave(false)
    }, [chatflowName])

    useEffect(() => {
        setChatflowName(flowName)
    }, [flowName])

    const component = show ? (
        <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="fixed inset-0 bg-gray-600 opacity-50" onClick={onCancel}></div>
            <div className="bg-white rounded-lg shadow-lg max-w-sm mx-4 relative z-10">
                <div className="p-4 border-b border-gray-300">
                    <h3 className="text-lg font-semibold" id='alert-dialog-title'>
                        {dialogProps.title}
                    </h3>
                </div>
                <div className="p-4">
                    <input
                        id='chatflow-name'
                        type='text'
                        className="w-full p-2 border border-gray-300 rounded-md mt-2"
                        placeholder='My New Chatflow'
                        value={chatflowName}
                        onChange={(e) => setChatflowName(e.target.value)}
                    />
                </div>
                <div className="p-4 border-t border-gray-300 flex justify-end space-x-2">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100"
                    >
                        {dialogProps.cancelButtonName}
                    </button>
                    <button
                        disabled={!isReadyToSave}
                        onClick={() => onConfirm(chatflowName)}
                        className={`px-4 py-2 rounded-md text-white ${isReadyToSave ? 'bg-blue-500 hover:bg-blue-600' : 'bg-gray-300 cursor-not-allowed'}`}
                    >
                        {dialogProps.confirmButtonName}
                    </button>
                </div>
            </div>
        </div>
    ) : null

    return portalElement ? createPortal(component, portalElement) : null;
}

SaveChatflowDialog.propTypes = {
    show: PropTypes.bool,
    dialogProps: PropTypes.object,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func
}

export default SaveChatflowDialog
